import { HealthStatusCard } from '@/components/HealthStatusCard';
import { BotStatusCard } from '@/components/BotStatusCard';

export function StatusPage() {
  return (
    <div className="px-4 md:px-8 py-12 max-w-2xl mx-auto space-y-4">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">Status</h1>
        <p className="text-small text-text-secondary">
          This page reflects the real, live status of both the Dem Web API and the Dem bot itself.
          If the bot is temporarily offline, the website stays online and says so plainly rather
          than showing fabricated data.
        </p>
      </div>
      <BotStatusCard />
      <HealthStatusCard />
    </div>
  );
}
